module.exports = __webpack_public_path__ + "img/icon_caozuodianji_finish.dc6933ba.svg";